import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import classes from "./EasyGamePage2.module.css";
import {
  resetEasyQuestions,
  storeEasyQuestions,
} from "../Slices/easyQuestionsSlice";
import { easyQuestionsApi, saveScoreApi, winnerApi } from "../Api/api";
import axios from "axios";
import { increaseIndex, resetIndex } from "../Slices/indexSlice";
import {
  easyModeScoreDecrease,
  easyModeScoreIncrease,
  setUserScore,
} from "../Slices/userSlice";
import { useNavigate } from "react-router-dom";
import {
  DecreaseTime,
  IncreaseTimeForProgress,
  ResetTime,
  ResetTimeForProgress,
  SetProgress,
} from "../Slices/timeSlice";
import Cookies from "js-cookie";
import { motion, useAnimation } from "framer-motion";
import {
  resetCorrectIndex,
  resetWrongIndex,
  storeCorrectIndex,
  storeWrongIndex,
} from "../Slices/correctWrongSlice";
import BackgroundAudio from "../Components/BackgroundAudio";
import CorrectAnswerAudio from "../Components/CorrectAnswerAudio";
import WrongAnswerAudio from "../Components/WrongAnswerAudio";
import Lottie from "lottie-react";
import correctAnimation from "../StaticAnimations/correctAnimation.json";
import toast from "react-hot-toast";
import Loading from "../Components/Loading";
import {
  increaseCorrect,
  increaseWrong,
  resetCorrect,
  resetWrong,
} from "../Slices/totalCorrectWrongSlice";
import { increaseSkip, resetSkip } from "../Slices/skipSlice";
import Stepper from "../Components/Stepper";
import { resetStepper, storeStepper } from "../Slices/stepperSlice";
import {
  resetOriginalCorrectIndex,
  storeOriginalCorrectIndex,
} from "../Slices/originalCorrectSlice";
import Timer from "../Components/GameComponents/Timer";
import GameMode from "../Components/GameComponents/GameMode";
import Layout from "../Components/UI/Layout";
import SubLayout from "../Components/UI/SubLayout";
import QuizAnimation from "../Components/GameComponents/QuizAnimation";
import QuestionMarkAnimation from "../Components/GameComponents/QuestionMarkAnimation";
import Button3d from "../Components/GameComponents/Button3d";
import QuestionBox from "../Components/GameComponents/QuestionBox";
import OptionBox from "../Components/GameComponents/OptionBox";
import ScoreBox from "../Components/GameComponents/ScoreBox";
import levelupAnimation from "../StaticAnimations/levelupAnimation.json";
import GamePopup from "../Components/GameComponents/GamePopup";
import { resetMediumQuestions } from "../Slices/mediumQuestionsSlice";
import { resetHardQuestions } from "../Slices/hardQuestionsSlice";
import { resetPracticeState } from "../Slices/practiceQuestionsSlice";

const EasyGamePage2 = () => {
  const controls = useAnimation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [winner, setWinner] = useState(false);
  const [popup, setPopup] = useState(false);
  const [pointerEvents, setPointerEvents] = useState("all");
  const dispatch = useDispatch();
  const { easyQuestions } = useSelector((state) => state?.easyQuestions);
  const { originalCorrect } = useSelector(
    (state) => state?.originalCorrectSlice
  );
  const { score, user } = useSelector((state) => state?.userSlice);

  useEffect(() => {
    if (score == 0) {
      winnerApiHit();
    }
  }, [score]);

  const winnerApiHit = async () => {
    const data = {
      ani: user,
      score: score,
      questionCount: index + 1,
    };
    let headers = {
      Authorization: `Bearer ${Cookies.get("token")}`,
    };
    try {
      setWinner(true);
      const res = await axios.post(`${saveScoreApi}`, data, {
        headers: headers,
      });
      dispatch(setUserScore(parseInt(res?.data?.score, 0)));
      try {
        const data2 = {
          ani: user,
          score: 0,
          questionCount: res?.data?.questionCount,
        };
        let headers = {
          Authorization: `Bearer ${Cookies.get("token")}`,
        };
        setWinner(true);
        const response = await axios.post(`${winnerApi}`, data2, {
          headers: headers,
        });
        dispatch(setUserScore(parseInt(0, 0)));
        setTimeout(() => {
          setWinner(false);
          navigate("/game/winner");
        }, 1500);
      } catch (error) {
        setTimeout(() => {
          setWinner(false);
        }, 100);
        toast.error(
          error?.data?.message ||
            error?.data?.response?.message ||
            error?.message
        );
      }
    } catch (error) {
      toast.error(
        error?.data?.message || error?.message || error?.data?.response?.message
      );
    }
  };

  useEffect(() => {
    if (!Cookies.get("token")) {
      navigate("/");
    }
    if (!easyQuestions) {
      dispatch(resetStepper());
      dispatch(resetEasyQuestions());
      dispatch(resetMediumQuestions());
      dispatch(resetHardQuestions());
      dispatch(resetSkip());
      dispatch(resetCorrect());
      dispatch(resetWrong());
      dispatch(resetCorrectIndex());
      dispatch(resetWrongIndex());
      dispatch(resetIndex());
      dispatch(ResetTime());
      dispatch(ResetTimeForProgress());
      dispatch(resetPracticeState());
      dispatch(resetOriginalCorrectIndex());
      getQuestionsFromBackend();
    } else {
      setLoading(false);
    }
  }, [easyQuestions, Cookies]);

  useEffect(() => {
    window.history.pushState(null, null, document.URL);
    window.addEventListener("popstate", function () {
      window.history.pushState(null, null, document.URL);
    });
  }, [window]);

  const navigateToBack = () => {
    saveScore("/");
  };

  const cancelPopupHandler = () => {
    setPopup(false);
    navigate("/");
  };

  const getQuestionsFromBackend = async () => {
    try {
      setLoading(true);
      let headers = {
        Authorization: `Bearer ${Cookies.get("token")}`,
      };
      const res = await axios.get(`${easyQuestionsApi}&ani=${user}`, {
        headers: headers,
      });
      dispatch(storeEasyQuestions(res?.data?.Easy));
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  // useEffect(() => {
  //   if (!easyQuestions || easyQuestions?.length <= 0) {
  //     getQuestionsFromBackend();
  //   } else {
  //     setLoading(false);
  //   }
  // }, []);

  const { time, progress } = useSelector((state) => state?.timeSlice);

  const { skip } = useSelector((state) => state.skipSlice);

  const { index } = useSelector((state) => state?.indexSlice);

  const { totalCorrect, totalWrong } = useSelector(
    (state) => state.totalCorrectWrongSlice
  );

  useEffect(() => {
    if (totalWrong > 2) {
      saveScore("/game/lose");
    }
  }, [totalWrong]);

  async function saveScore(path, object) {
    const data = {
      ani: user,
      score: score,
      questionCount: index + 1,
    };
    let headers = {
      Authorization: `Bearer ${Cookies.get("token")}`,
    };
    try {
      const res = await axios.post(`${saveScoreApi}`, data, {
        headers: headers,
      });
      dispatch(setUserScore(parseInt(res?.data?.score, 0)));
      if (object?.showPopup) {
        dispatch(resetCorrectIndex());
        dispatch(resetWrongIndex());
        dispatch(resetCorrect());
        dispatch(resetWrong());
        setPopup(true);
      } else {
        setTimeout(() => {
          console.log("hit here");
          navigate(path);
        }, 1000);
      }
    } catch (error) {
      toast.error(
        error?.data?.message ||
          error?.response?.data?.message ||
          error?.data ||
          error?.message
      );
    }
  }

  useEffect(() => {
    if (!loading && !popup) {
      if (time > 0) {
        const timeoutId = setTimeout(() => {
          dispatch(DecreaseTime());
          dispatch(IncreaseTimeForProgress());
          dispatch(SetProgress());
        }, 1000);

        return () => clearTimeout(timeoutId);
      } else {
        saveScore("/game/lose");
      }
    }
  }, [loading, time, dispatch, navigate, popup]);

  const { correct, wrong } = useSelector((state) => state?.correctWrongSlice);

  const checkAnswerAndIncreaseIndex = (data) => {
    if (index >= easyQuestions?.length - 1) {
      if (easyQuestions[index]?.correctAnswer == data?.option) {
        dispatch(storeStepper({ index: index, correct: true, skip: false }));
        dispatch(storeCorrectIndex(data?.option));
        dispatch(increaseCorrect());
        dispatch(easyModeScoreDecrease());
        saveScore("/game/medium", { showPopup: true });
      } else {
        dispatch(storeStepper({ index: index, correct: false, skip: false }));
        dispatch(storeWrongIndex(data?.option));
        dispatch(increaseWrong());
        dispatch(easyModeScoreIncrease());
        dispatch(
          storeOriginalCorrectIndex(easyQuestions[index]?.correctAnswer)
        );
        // Here if total wrong is more than 2 or equal to 2 because state takes time to update
        if (totalWrong >= 2) {
          saveScore("/game/lose");
        } else {
          saveScore("/game/medium", { showPopup: true });
        }
      }
      // hit api here and save the score in backend
      // saveScore("/game/medium", { showPopup: true });
    } else {
      if (easyQuestions[index]?.correctAnswer == data?.option) {
        dispatch(storeCorrectIndex(data?.option));
        dispatch(easyModeScoreDecrease());
        dispatch(increaseCorrect());
        dispatch(storeStepper({ index: index, correct: true, skip: false }));
        setPointerEvents("none");
        setTimeout(() => {
          const animationConfig = {
            opacity: 0,
            transition: { duration: 0.5 },
          };

          controls.start(animationConfig).then(() => {
            dispatch(resetCorrectIndex());
            dispatch(increaseIndex());
            setPointerEvents("all");
            controls.start({ opacity: 1, transition: { duration: 0.5 } });
          });
        }, 500);
      } else {
        dispatch(storeWrongIndex(data?.option));
        dispatch(easyModeScoreIncrease());
        dispatch(increaseWrong());
        dispatch(storeStepper({ index: index, correct: false, skip: false }));
        dispatch(
          storeOriginalCorrectIndex(easyQuestions[index]?.correctAnswer)
        );
        setPointerEvents("none");
        setTimeout(() => {
          const animationConfig = {
            opacity: 0,
            transition: { duration: 0.5 },
          };

          if (!(totalWrong > 1)) {
            controls.start(animationConfig).then(() => {
              dispatch(resetWrongIndex());
              dispatch(increaseIndex());
              dispatch(resetOriginalCorrectIndex());
              setPointerEvents("all");
              controls.start({ opacity: 1, transition: { duration: 0.5 } });
            });
          }
        }, 500);
      }
    }
  };

  const skipHandler = () => {
    if (index >= easyQuestions?.length - 1) {
      dispatch(increaseSkip());
      dispatch(easyModeScoreIncrease());
      dispatch(increaseWrong());
      if (totalWrong >= 2) {
        saveScore("/game/lose");
      } else {
        saveScore("/game/medium", { showPopup: true });
      }
      // saveScore("/game/medium", { showPopup: true });
    } else {
      dispatch(easyModeScoreIncrease());
      dispatch(increaseWrong());
      dispatch(increaseSkip());
      dispatch(storeStepper({ index: index, correct: null, skip: true }));
      dispatch(storeOriginalCorrectIndex(easyQuestions[index]?.correctAnswer));

      setTimeout(() => {
        const animationConfig = {
          opacity: 0,
          transition: { duration: 0.2 },
        };

        // Here the totalWrong is greater than 1 bcoz the state takes time to increase by 1
        if (!(totalWrong > 1)) {
          controls.start(animationConfig).then(() => {
            dispatch(increaseIndex());
            dispatch(resetOriginalCorrectIndex());
            controls.start({ opacity: 1, transition: { duration: 0.2 } });
          });
        }
      }, 500);
    }
  };

  const playAgainHandlerForPopup = () => {
    setPopup(false);
    getQuestionsFromBackend();
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : winner ? (
        <div className={classes.container} style={{ height: "100dvh" }}>
          <div
            className={classes.sub_container}
            style={{
              height: "90dvh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "1rem",
            }}
          >
            <div className={classes.levelupAnimationContainer}>
              <Lottie
                animationData={levelupAnimation}
                loop={true}
                autoplay={true}
                className={classes.levelupAnimation}
              />
            </div>
          </div>
        </div>
      ) : (
        <>
          <BackgroundAudio />
          {correct && <CorrectAnswerAudio />}
          {wrong && <WrongAnswerAudio />}
          <Layout>
            <Timer progress={progress} time={time} />

            <GameMode mode="Easy Mode" navigateToBack={navigateToBack} />

            <Stepper index={index} />

            <SubLayout>
              <QuizAnimation />

              <div className={classes.questions_options_container}>
                <QuestionMarkAnimation />

                <div className={classes.skip_button}>
                  <Button3d text="Skip" skipHandler={skipHandler} />
                </div>

                <motion.div
                  initial={{ opacity: 1 }}
                  animate={controls}
                  className={classes.questions_options_sub_container}
                  style={{ pointerEvents: pointerEvents }}
                >
                  <QuestionBox question={easyQuestions[index]?.question} />

                  <div className={classes.options_box}>
                    <OptionBox
                      originalCorrect={originalCorrect}
                      wrong={wrong}
                      originalCorrectValue="1"
                      wrongValue="1"
                      optionIndex={{ option: "1" }}
                      option={easyQuestions[index]?.optionA}
                      checkAnswerAndIncreaseIndex={checkAnswerAndIncreaseIndex}
                    />

                    <OptionBox
                      originalCorrect={originalCorrect}
                      wrong={wrong}
                      originalCorrectValue="2"
                      wrongValue="2"
                      optionIndex={{ option: "2" }}
                      option={easyQuestions[index]?.optionB}
                      checkAnswerAndIncreaseIndex={checkAnswerAndIncreaseIndex}
                    />

                    <OptionBox
                      originalCorrect={originalCorrect}
                      wrong={wrong}
                      originalCorrectValue="3"
                      wrongValue="3"
                      optionIndex={{ option: "3" }}
                      option={easyQuestions[index]?.optionC}
                      checkAnswerAndIncreaseIndex={checkAnswerAndIncreaseIndex}
                    />

                    <OptionBox
                      originalCorrect={originalCorrect}
                      wrong={wrong}
                      originalCorrectValue="4"
                      wrongValue="4"
                      optionIndex={{ option: "4" }}
                      option={easyQuestions[index]?.optionD}
                      checkAnswerAndIncreaseIndex={checkAnswerAndIncreaseIndex}
                    />
                  </div>

                  <ScoreBox score={score} />

                  {correct && (
                    <div className={classes.overlapContainer}>
                      <div className={classes.overlapAnimationContainer}>
                        <Lottie
                          animationData={correct && correctAnimation}
                          loop={true}
                          autoplay={true}
                          className={classes.overlapAnimation}
                        />
                      </div>
                    </div>
                  )}
                </motion.div>
              </div>
              {popup && (
                <GamePopup
                  playAgainNavigation="/game/easy"
                  mode1="Medium Mode"
                  mode1Navigation="/game/medium"
                  mode2="Hard Mode"
                  mode2Navigation="/game/hard"
                  playAgainHandler={playAgainHandlerForPopup}
                  cancelHandler={cancelPopupHandler}
                />
              )}
            </SubLayout>
          </Layout>
        </>
      )}
    </>
  );
};

export default EasyGamePage2;
